<template>
    <card class="progress-card">
        <div slot="header">
            <span class="avatar rounded-circle float-left">
                <img :src="tester.avatar">
            </span>
            <h3 style="padding:10px 0 0 60px">
                {{ tester.name }}
            </h3>
        </div>

        <div class="mb-4">
            <h3>Observation</h3>
            <base-progress :type="observationProgressColor(observationProgress)" :value="observationProgress" size="lg"></base-progress>
            <h5 class="mt--3">{{ observationProgress }}%</h5>
        </div>

        <div>
            <h3>Evaluation</h3>
            <base-progress :type="evaluationProgressColor(evaluationProgress)" :value="evaluationProgress" size="lg"></base-progress>
            <h5 class="mt--3" :class="'text-'+evaluationProgressColor(evaluationProgress)">{{ evaluationProgress }}%</h5>
        </div>
    </card>
</template>

<script>
    export default {

        props: {
            progress: {
                type: Object,
                required: true
            },

            tester: {
                type: Object,
                required: true
            },
        },

        computed: {

            observationProgress() {
                return this.progress[this.tester.id] && this.progress[this.tester.id].observation
                    ? this.progress[this.tester.id].observation
                    : 0;
            },

            evaluationProgress() {
                return this.progress[this.tester.id] && this.progress[this.tester.id].evaluation
                    ? this.progress[this.tester.id].evaluation
                    : 0;
            },
        },

        methods: {

            observationProgressColor(value) {
                return 'info'
            },

            evaluationProgressColor(value) {
                if (value == 0) {
                    return 'danger'
                }
                if (value < 100) {
                    return 'warning'
                }
                return 'success'
            },
        }
    }
</script>

<style lang="css" scoped>

    .progress-card >>> .card-header {
        padding: 0.7rem 1.5rem 0.7rem 1.5rem;
    }
    .progress-card >>> .card-header h3 {
        text-transform: none !important;
    }

</style>


